import 'moment/locale/fr';
import moment from 'moment';

export default () => {
  moment.updateLocale('fr', {
    months: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split(
      '_'
    ),
    weekdays: 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split('_'),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/date.js